import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { Link } from 'react-router-dom';

import axios from 'axios';
import axios_api from "../Api";

import { GetTemplateType } from './TemplateForm'
import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import Loader from "./common/Loader";


function Template({id, name, type, file, groups}){

  const media_url = useContext(MEDIA_URL);
  let typeDisplay =GetTemplateType(type)

  //console.log(groups)
  let groupNames = groups.map(x => (x.name + ', '));
  console.log(groupNames)

  return(
    <tr>
      <td><Link className="" to={`/template/` + id}>{name}</Link> </td>
      <td>{typeDisplay}</td>
      <td><a className="m-1" href={media_url + file} download>скачать</a></td>
      <td>{groupNames}</td>
    </tr>
  )
}

function TemplateList({templates}){
  let rows = [];

  console.log(templates);

  for(let i in templates) {
    rows.push(
      <Template
        key={templates[i].id}
        id={templates[i].id}
        name={templates[i].name}
        type={templates[i].type}
        file={templates[i].template_file}
        groups={templates[i].group}
      />
    );
  }

  return(
    <>
      <h5>шаблоны</h5>
      <table className="table">
        <thead>
          <tr>
            <th>название</th>   
            <th>тип</th>  
            <th>файл</th>   
            <th>группы</th> 
          </tr>
        </thead>
        <tbody>
          {rows} 
        </tbody>
      </table>
    </>
  )
}


function Group({id, name}){
  return(
    <tr>
      <td><Link className="" to={`/group/` + id}>{name}</Link></td> 
    </tr>
  )
}

function GroupList({groups}){

  console.log(groups);

  let rows = [];
  for(let i in groups) {
    rows.push(
      <Group
        key={groups[i].id}
        id={groups[i].id}
        name={groups[i].name}
      />
    );
  }

  return(
    <>
      <h5>группы</h5>
      <table className="table">
        <thead>
          <tr>
            <th>название</th>   
          </tr>
        </thead>
        <tbody>
          {rows} 
        </tbody>
      </table>
    </>
  )  
}


export default function GroupsTemplates({}) {
  const [templates, setTemplates] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);


  React.useEffect(() => {

      let templates = axios_api.get(api_url + '/templates', {
        headers: {"Authorization": token},
      });
  
      templates.then(
        (result) => {
          let apiReturnedTemplates = result.data;
          setTemplates(apiReturnedTemplates);

          let groups = axios_api.get(api_url + '/groups', {
            headers: {"Authorization": token},
          });

          groups.then(
            (result) => {
              let apiReturnedGroups = result.data;
              setGroups(apiReturnedGroups);
              setLoading(false);
  
            },
            (error) => {
              console.log(error)
              setGroups([]);
              setLoading(false);
            }
          );

        },
        (error) => {
          console.log(error)
          setTemplates([]);
          setLoading(false);
        }
      );
  
  }, []);

  return ( loading ? 
    (
      <Loader/>
    ) : (
      <>
        <div className="row">
        <h3 className="m-3">Шаблоны и Группы</h3>
        </div>
        <Link className="m-3 lk-button" to={`/template/create`}>
          Создать шаблон
        </Link> 
        <div className="row">
          <div className="col-7 m-3">
            <TemplateList
              templates={templates}
            />
          </div>
          <div className="col-3 m-3">
            <GroupList
              groups={groups}
            />
          </div>
        </div>
      </>
    )
  );
}
